import React from 'react'
import { CloseCircleFilled } from '@ant-design/icons'
import { Spin } from 'hljd'
import style from './style.module.less'
import { getAfterFixUrl } from '@components/Hotel/util'

export default ({ src, onDelete, isLoading = false, isVideo = false }) => {
  return (
    <div>
      <div className={isVideo ? style.videoCard : style.photoCard}>
        {onDelete && (
          <CloseCircleFilled className={style.icon} onClick={onDelete} />
        )}
        {src && <img src={getAfterFixUrl(src)} />}
        {isVideo && <i className={`iconfont icon-bofang ${style.play}`} />}

        <Spin spinning={isLoading} />
      </div>
    </div>
  )
}
